function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';
const Underwritting = props => /*#__PURE__*/React.createElement(Svg, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 221,
  height: 125,
  fill: "none"
}, props), /*#__PURE__*/React.createElement(G, {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement(Path, {
  stroke: "#545F71",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M29.083 88.708h44.933m-44.933 25.387h44.933m-44.933-12.687h44.933M3.679 124.349h185.359m-6.761-51.452v51.452m-46.536-52.103v52.103m-42.418-57.92h51.85M20.589 124.35V77.972h61.92v46.377m13.094-56.006v56.006M9.046 68.343v56.006m50.509-81.446h71.796l23.789 17.294m33.924 17.216-29.795-19.806-32.543 20.378m-23.684-4.36L52.35 37.673.878 74.446m123.764 50.125V90.647h-17.718v33.924m62.168-23.332h-20.167V80.965h20.167v20.274Z"
}), /*#__PURE__*/React.createElement(Path, {
  fill: "#EBF1FF",
  stroke: "#111C2B",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  d: "M167.829 103.919c28.37 0 51.368-22.971 51.368-51.309 0-28.337-22.998-51.309-51.368-51.309s-51.369 22.972-51.369 51.31c0 28.337 22.999 51.308 51.369 51.308Z"
}), /*#__PURE__*/React.createElement(G, {
  stroke: "#111C2B",
  strokeWidth: 2,
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement(Path, {
  strokeMiterlimit: 10,
  d: "m156.445 56.429 7.608 7.605-17.098 17.104a5.348 5.348 0 0 1-7.551.001l-.055-.055a5.34 5.34 0 0 1-.002-7.551l17.098-17.104ZM154.58 58.313l7.607 7.607M166.14 58.87l-3.616 3.616-4.51-4.51 3.616-3.616"
}), /*#__PURE__*/React.createElement(Path, {
  strokeMiterlimit: 10,
  d: "M177.96 62.784c11.18 0 20.244-9.063 20.244-20.244 0-11.18-9.064-20.244-20.244-20.244-11.181 0-20.244 9.064-20.244 20.244s9.063 20.244 20.244 20.244Z"
}), /*#__PURE__*/React.createElement(Path, {
  strokeMiterlimit: 10,
  d: "M177.96 58.61c8.876 0 16.071-7.194 16.071-16.07 0-8.876-7.195-16.07-16.071-16.07-8.876 0-16.071 7.194-16.071 16.07 0 8.876 7.195 16.07 16.071 16.07Z"
}), /*#__PURE__*/React.createElement(Path, {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m185.982 38.133-11.068 11.069-5.106-5.107"
}))), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
  id: "a"
}, /*#__PURE__*/React.createElement(Path, {
  fill: "#fff",
  d: "M.5 0h220v125H.5z"
})), /*#__PURE__*/React.createElement(ClipPath, {
  id: "b"
}, /*#__PURE__*/React.createElement(Path, {
  fill: "#fff",
  d: "M136.5 21h63v63h-63z"
}))));
export default Underwritting;
//# sourceMappingURL=Underwriting.js.map